var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{attrs:{"id":"map"}}),_c('Selector',{attrs:{"activeIndex":_vm.activeIndex},on:{"change":(payload) => (_vm.activeIndex = payload)}}),(_vm.activeIndex === 0)?_c('DataCenter'):_vm._e(),(_vm.activeIndex === 1)?_c('History'):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }